import React from 'react';
import Select from 'react-select'

const FloatingLabelSelect = ({
  label,
  id,
  name,
  value,
  onChange,
  options = [],
  className = '',
  isClearable = false,
  isDisabled = false,
  isSearchable = false,
  isMulti = false
}) => {
  return (
    <div className={`relative w-full ${className}`}>
       <Select
       
        className="basic-single"
        classNamePrefix="select"
        value ={value}
        isDisabled={isDisabled}
        isClearable={isClearable}
        isSearchable={isSearchable}
        onChange={onChange}
        name={name}
        options={options}
        isMulti = {isMulti}
      />
      <label
        htmlFor={id}
        className="absolute left-3 -top-3.5 bg-white px-1 text-sm text-gray-500 transition-all 
          peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 
          peer-focus:-top-3.5 peer-focus:text-sm peer-focus:text-blue-500"
      >
        {label}
      </label>
    </div>
  );
};

export default FloatingLabelSelect;
